import API from "api/axiosInstance";
import { setDashboardSummary, setIsLoading, setStatus } from "./index";

export const fetchDashboardSummary = (forceRefresh = false) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/api/dashboard/summary", {
      params: forceRefresh ? { refresh: Date.now() } : undefined,
    });
    dispatch(setDashboardSummary(response.data.data));
  } catch (error) {
    dispatch(setStatus("failed"));
  } finally {
    dispatch(setIsLoading(false));
  }
};
